import { store } from '@/context/store';

import { postUrl } from '../fetch';

export async function postMeLenderBiasAction(
    action: 'preapproved' | 'customerSelectLender',
    lenders: string[]
): Promise<void> {
    try {
        const state = store.getState();
        const applicationId = state.borrowerReducer.application.applicationId;

        const body = {
            applicationId,
            action,
            lenders,
        };

        const url = `/api/meLenderBias/action`;

        const res = await postUrl<any>(url, body);
        return res.data;
    } catch (error) {
        console.error(error);
        return;
    }
}
